import { RequestURL } from "@campgladiator/cg-common.types.types";

export const buildUrl = (requestURL: RequestURL): string =>
  `${requestURL.baseUrl + requestURL.endpoint + (requestURL.params || "")}`;
